import { useState, useEffect } from "react";
import useWebSocket from "react-use-websocket";

export const useWebsocketFetch = ({ onSuccess, onError, onEmpty }) => {
  const [socketUrl, setSocketUrl] = useState(null);
  const [status, setStatus] = useState("off");
  const [data, setData] = useState([]);

  const { sendJsonMessage, lastJsonMessage } = useWebSocket(socketUrl, {
    onOpen: () => {
      setStatus("on");
      setData([]);
    },
    onClose: () => {
      if (
        (data?.length === 0 && status === "fetching") ||
        (data?.length === 1 &&
          (data[0]?.MessageResponse === "Nenhum registro localizado." ||
            data[0]?.MessageResponse === "Falha em validação de filtros!"))
      ) {
        setStatus("empty");
        setStatus("off");
      }

      if (data?.length !== 0) {
        onSuccess(data);
        setStatus("off");
      }
      setData([]);
    },
    onError: (error) => {
      setStatus("error");
      if (onError) {
        onError(error);
      }
    },
    shouldReconnect: () => true,
    reconnectInterval: 2000,
  });

  const handleFetchData = (data) => {
    setStatus("fetching");
    sendJsonMessage(data);
  };

  const handleFetchUrl = (url) => {
    setSocketUrl(url);
  };

  const onMessageReceive = (response) => {
    if (
      !response?.Result ||
      response?.message === "Forbidden" ||
      response?.Result[0]?.MessageResponse === "Nenhum registro localizado." ||
      response?.Result[0]?.MessageResponse === "Falha em validação de filtros!"
    ) {
      setStatus("empty");
      if (onEmpty) {
        onEmpty();
      }
      return;
    }
    setData((prevData) => [...prevData, ...response?.Result]);
  };

  const cancel = () => {
    sendJsonMessage({ status: "inactive" });
  };

  useEffect(() => {
    if (lastJsonMessage) {
      onMessageReceive(lastJsonMessage);
    }
  }, [lastJsonMessage]);

  return {
    handleFetchData,
    handleFetchUrl,
    data,
    status,
    cancel,
  };
};
